import React, { useEffect } from 'react';

import './Info.css';

export const Info = ({ topic, query, stance, mode }) => {
  useEffect(() => {}, []);

  return (
    <div className='info-container'>
      <div className='info-row'>
        <span>Topic:</span> {topic}
      </div>
      <div className='info-row'>
        <span>Query:</span> {query}
      </div>
      {mode === 'detailed' && (
        <div className='info-row'>
          <span>Stance:</span> {stance}
        </div>
      )}
    </div>
  );
};
